import React from 'react'
import { OneColorIconProps } from '../utils'

export const GuildSilverIcon: React.FC<OneColorIconProps> = ({ size = 24, className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 37 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M2.92107 1.05566H34.079C35.0912 1.05566 35.9118 1.86667 35.9118 2.87229V17.2408C35.9118 24.7927 30.2259 33.2254 20.6227 36.7848C19.2542 37.292 17.7459 37.292 16.3774 36.7848C6.77419 33.2254 1.08826 24.7927 1.08826 17.2408V2.87291C1.08826 1.86729 1.90884 1.05566 2.92107 1.05566Z"
        fill="url(#paint0_linear_147_2354)"
      />
      <path
        d="M2.92107 1.05566H34.079C35.0912 1.05566 35.9118 1.86667 35.9118 2.87229V17.2408C35.9118 24.7927 30.2259 33.2254 20.6227 36.7848C19.2542 37.292 17.7459 37.292 16.3774 36.7848C6.77419 33.2254 1.08826 24.7927 1.08826 17.2408V2.87291C1.08826 1.86729 1.90884 1.05566 2.92107 1.05566Z"
        fill="url(#paint1_linear_147_2354)"
        fillOpacity="0.51"
      />
      <path
        d="M2.92107 1.05566H34.079C35.0912 1.05566 35.9118 1.86667 35.9118 2.87229V17.2408C35.9118 24.7927 30.2259 33.2254 20.6227 36.7848C19.2542 37.292 17.7459 37.292 16.3774 36.7848C6.77419 33.2254 1.08826 24.7927 1.08826 17.2408V2.87291C1.08826 1.86729 1.90884 1.05566 2.92107 1.05566Z"
        fill="url(#paint2_linear_147_2354)"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.92109 0.263916H34.079C35.5467 0.263916 36.728 1.4222 36.728 2.84588V17.0062C36.728 25.3737 29.9168 34.6297 18.7225 37.7062C18.5771 37.7461 18.423 37.7461 18.2775 37.7062C7.08323 34.6297 0.272095 25.3737 0.272095 17.0062V2.84649C0.272095 1.42315 1.45302 0.263916 2.92109 0.263916ZM18.5 36.9445C29.3824 33.9537 35.9118 24.9815 35.9118 17.0062V2.84588C35.9118 1.85484 35.0912 1.05558 34.079 1.05558H2.92109C1.90885 1.05558 1.08827 1.85544 1.08827 2.84649V17.0062C1.08827 24.9815 7.61768 33.9537 18.5 36.9445Z"
        fill="url(#paint3_linear_147_2354)"
      />
      <path
        d="M2.42843 18.8627C2.69598 27.3758 10.9903 33.1427 17.4117 35.8889C15.6363 22.8282 15.6306 15.3025 17.4117 2.11108C17.4117 2.11108 2.96354 2.11142 2.42842 2.11108C1.90096 2.11075 2.35408 16.5015 2.42556 18.7716L2.42843 18.8627Z"
        fill="url(#paint4_linear_147_2354)"
        fillOpacity="0.45"
      />
      <path
        d="M18.5988 15.5158H24.5808C24.6952 15.5245 24.8095 15.5766 24.8623 15.6635C24.9415 15.7416 24.9943 15.8546 24.9943 15.9762V23.6115C24.9943 23.6723 24.9767 23.7418 24.9503 23.8026C24.9239 23.8634 24.8799 23.9155 24.8271 23.959C22.9973 24.8971 20.9564 25.3662 18.8891 25.3314C14.1386 25.2185 10.3383 21.5789 10.3383 16.8882C10.3383 12.2063 14.1386 8.38425 18.8891 8.44505C20.8948 8.50586 23.1117 9.3745 24.7392 10.8338C24.7919 10.8686 24.8359 10.9207 24.8623 10.9728C24.8975 11.0249 24.9151 11.0857 24.9151 11.1465C24.9151 11.2073 24.9063 11.2681 24.8799 11.3289C24.8535 11.3811 24.8183 11.4332 24.7744 11.4766L22.9182 13.3963C22.8214 13.4571 22.707 13.4919 22.5927 13.4919C22.4783 13.4919 22.3639 13.4571 22.2672 13.3963C21.3611 12.519 20.2966 12.1976 19.1442 12.1715C16.2499 12.1107 14.4553 14.2997 14.4553 16.8622C14.4553 19.4507 16.2499 21.5442 19.1706 21.605C19.8919 21.6223 20.6045 21.5181 21.2907 21.2836V18.9035C20.7629 18.8774 19.0563 18.8774 18.5812 18.8774C18.5196 18.8774 18.4668 18.8687 18.4052 18.8514C18.3524 18.8253 18.2997 18.7992 18.2557 18.7558C18.2117 18.7124 18.1765 18.6603 18.1501 18.6081C18.1237 18.556 18.1149 18.4952 18.1149 18.4344V15.9501C18.1149 15.8893 18.1237 15.8285 18.1501 15.7764C18.1765 15.7243 18.2117 15.6721 18.2557 15.6287C18.2997 15.5853 18.3524 15.5505 18.414 15.5332C18.4756 15.5158 18.5372 15.5071 18.5988 15.5158Z"
        fill="url(#paint5_linear_147_2354)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.15 18.6083C18.1236 18.5562 18.1149 18.4954 18.1149 18.4346V15.9503C18.1149 15.8895 18.1236 15.8287 18.15 15.7766C18.1764 15.7245 18.2116 15.6723 18.2556 15.6289C18.2996 15.5855 18.3524 15.5507 18.414 15.5334C18.4755 15.516 18.5371 15.5073 18.5987 15.516H24.5807C24.6951 15.5247 24.8095 15.5768 24.8623 15.6636C24.9414 15.7418 24.9942 15.8547 24.9942 15.9764V23.6117C24.9942 23.6725 24.9766 23.742 24.9502 23.8028C24.9238 23.8636 24.8798 23.9157 24.8271 23.9592C22.9973 24.8973 20.9563 25.3664 18.889 25.3316C14.1385 25.2187 10.3382 21.5791 10.3382 16.8884C10.3382 12.2065 14.1385 8.38444 18.889 8.44524C20.8947 8.50605 23.1116 9.37469 24.7391 10.834C24.7919 10.8688 24.8359 10.9209 24.8623 10.973C24.8974 11.0251 24.915 11.0859 24.915 11.1467C24.915 11.2075 24.9062 11.2683 24.8798 11.3291C24.8535 11.3812 24.8183 11.4334 24.7743 11.4768L22.9181 13.3965C22.8213 13.4573 22.707 13.492 22.5926 13.492C22.4782 13.492 22.3639 13.4573 22.2671 13.3965C21.361 12.5192 20.2965 12.1978 19.1441 12.1717C16.2499 12.1109 14.4552 14.2999 14.4552 16.8624C14.4552 19.4509 16.2499 21.5443 19.1705 21.6051C19.8919 21.6225 20.6044 21.5183 21.2906 21.2838V18.9037C20.7628 18.8776 19.0562 18.8776 18.5811 18.8776C18.5196 18.8776 18.4667 18.8689 18.4052 18.8516C18.3524 18.8255 18.2996 18.7994 18.2556 18.756C18.2116 18.7126 18.1764 18.6605 18.15 18.6083ZM20.7465 19.417C20.0338 19.4055 18.9536 19.4054 18.5811 19.4054C18.4585 19.4054 18.354 19.3868 18.2532 19.3583L18.204 19.3445L18.1583 19.3219C18.1557 19.3206 18.1527 19.3191 18.1494 19.3175C18.0996 19.2933 17.9759 19.2329 17.8674 19.1259C17.7744 19.034 17.7079 18.9323 17.6617 18.841C17.5844 18.6884 17.5707 18.5375 17.5707 18.4346V15.9503C17.5707 15.8474 17.5844 15.6965 17.6616 15.5439C17.7079 15.4526 17.7744 15.3509 17.8674 15.259M20.7465 19.417V20.8961C20.2378 21.031 19.7145 21.0903 19.184 21.0775L19.1822 21.0775C17.8604 21.05 16.8248 20.5664 16.1173 19.8236C15.4061 19.0767 14.9994 18.0384 14.9994 16.8624C14.9994 14.5385 16.5991 12.6464 19.1319 12.6994C20.1774 12.7231 21.0967 13.009 21.8827 13.77L21.9232 13.8093L21.9713 13.8394C22.1504 13.952 22.3666 14.0198 22.5926 14.0198C22.8186 14.0198 23.0348 13.952 23.2139 13.8395L23.2696 13.8045L25.1677 11.8414C25.258 11.751 25.3229 11.6514 25.3682 11.5618L25.3752 11.548L25.3813 11.5339C25.4428 11.3924 25.4591 11.2583 25.4591 11.1467C25.4591 10.9984 25.4191 10.847 25.3355 10.7117C25.2778 10.6078 25.1934 10.5062 25.0853 10.4258C23.3671 8.89559 21.0376 7.98234 18.906 7.91772L18.9011 7.91758L18.8962 7.91751C13.8237 7.85259 9.79407 11.9308 9.79407 16.8884C9.79407 21.8734 13.8381 25.7395 18.8757 25.8593L18.8796 25.8593C21.0381 25.8956 23.1698 25.4058 25.0813 24.4258L25.1338 24.3989L25.1791 24.3616C25.28 24.2785 25.3845 24.1624 25.4517 24.0076C25.4983 23.9003 25.5383 23.7604 25.5383 23.6117V15.9764C25.5383 15.7307 25.4419 15.5052 25.2919 15.3374C25.1139 15.0965 24.83 15.0055 24.6232 14.9898L24.602 14.9882H18.6287C18.4839 14.9757 18.3573 14.9997 18.262 15.0266C18.0918 15.0746 17.9613 15.1664 17.8674 15.259"
        fill="url(#paint6_linear_147_2354)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_147_2354"
          x1="6.52943"
          y1="3.46559"
          x2="19.503"
          y2="35.2085"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0439639" stopColor="#9D9C9B" />
          <stop offset="0.333786" stopColor="#C3C1C0" />
          <stop offset="0.721059" stopColor="#7B7979" />
          <stop offset="0.928708" stopColor="#595A5B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_147_2354"
          x1="1.36032"
          y1="-0.818723"
          x2="5.85966"
          y2="10.7443"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0179276" stopColor="#FFFCF6" stopOpacity="0.18" />
          <stop offset="0.523139" stopColor="#FFFAEF" />
          <stop offset="0.866895" stopColor="#F8F8F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_147_2354"
          x1="21.7647"
          y1="35.3302"
          x2="14.3439"
          y2="19.1736"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0179276" stopColor="#FFFCF6" stopOpacity="0.18" />
          <stop offset="0.523139" stopColor="#FFFAEF" />
          <stop offset="0.866895" stopColor="#F8F8F8" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_147_2354"
          x1="17.6959"
          y1="-0.776979"
          x2="22.2479"
          y2="33.3488"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.127299" stopColor="#C3C1C0" />
          <stop offset="1" stopColor="#3B3C3C" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_147_2354"
          x1="5.63914"
          y1="3.75878"
          x2="16.8478"
          y2="34.8827"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.42" />
          <stop offset="1" stopColor="white" stopOpacity="0.08" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_147_2354"
          x1="12.6524"
          y1="8.72491"
          x2="21.4799"
          y2="25.5046"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0416579" stopColor="#141313" />
          <stop offset="0.594408" stopColor="#3B3C3C" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_147_2354"
          x1="19.1464"
          y1="26.9827"
          x2="13.7358"
          y2="6.67941"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.127299" stopColor="#C3C1C0" />
          <stop offset="1" stopColor="#3B3C3C" />
        </linearGradient>
      </defs>
    </svg>
  )
}
